import script from "./EmployeeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeForm.vue?vue&type=style&index=0&id=5981e0d3&lang=css"

const __exports__ = script;

export default __exports__